export const PASSWORD_CHANGE_SOURCE = Object.freeze({
    FORGOTTEN_PASSWORD: 'forgotten_password',
    ADMIN_FORCE_RESET: 'admin_force_reset',
    UNKNOWN: 'unknown',
});

export const getLatestAuditLog = (auditLogsData) => {
    if (!auditLogsData?.auditlogs?.length) {
        return null;
    }
    return auditLogsData.auditlogs[0];
};

export const getPasswordChangerLabel = (auditLog) => {
    if (!auditLog) {
        return '';
    }
    if (auditLog.log_data?.changedByEmail) {
        return auditLog.log_data.changedByEmail;
    }
    if (auditLog.user_name) {
        return auditLog.user_name;
    }
    if (auditLog.log_data?.email) {
        return auditLog.log_data.email;
    }
    return '';
};

export const getPasswordChangeSource = (auditLog) => {
    if (!auditLog?.log_type) {
        return PASSWORD_CHANGE_SOURCE.UNKNOWN;
    }
    if (auditLog.log_type === 'reset_password') {
        if (auditLog.log_data?.changedByUserId) {
            return PASSWORD_CHANGE_SOURCE.ADMIN_FORCE_RESET;
        }
        return PASSWORD_CHANGE_SOURCE.FORGOTTEN_PASSWORD;
    }
    return PASSWORD_CHANGE_SOURCE.UNKNOWN;
};
